// extracted by mini-css-extract-plugin
export default {"cls1":"PaperImages-cls1__ffa775365f0e55266a72","cls2":"PaperImages-cls2__fbd877f880f11ec05559 PaperImages-cls1__ffa775365f0e55266a72"};